var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Create Cargo Seller Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Seller Cargo List"
    },
    on: {
      "click": _vm.showSellerCragoDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Seller ID "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellerid),
      expression: "sellerid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('sellerid')
    },
    attrs: {
      "type": "text",
      "name": "sellerid",
      "id": "sellerid",
      "placeholder": "Enter Seller Id"
    },
    domProps: {
      "value": (_vm.sellerid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellerid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sellerid')),
      expression: "errors.has('sellerid')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter seller id .")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Seller GST No "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellergstno),
      expression: "sellergstno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validate_gst'),
      expression: "'required|validate_gst'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('sellergstno')
    },
    attrs: {
      "type": "text",
      "name": "sellergstno",
      "id": "sellergstno",
      "placeholder": "Enter Seller GST No"
    },
    domProps: {
      "value": (_vm.sellergstno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellergstno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "gstBlock"
    }
  }, [_vm._v("Note: Allowed GST Format 00XXXXX0000X1ZZ.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sellergstno')),
      expression: "errors.has('sellergstno')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter seller GST No.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Seller Name "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellername),
      expression: "sellername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('sellername')
    },
    attrs: {
      "type": "text",
      "name": "sellername",
      "id": "sellername",
      "placeholder": "Enter Seller Name"
    },
    domProps: {
      "value": (_vm.sellername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sellername')),
      expression: "errors.has('sellername')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter seller name.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hub),
      expression: "hub"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "hub",
      "id": "hub",
      "placeholder": "Enter Hub Name"
    },
    domProps: {
      "value": (_vm.hub)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hub = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Pincode"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pincode),
      expression: "pincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('pincode')
    },
    attrs: {
      "type": "text",
      "name": "pincode",
      "id": "pincode",
      "placeholder": "Enter Pincode",
      "pattern": "^(\\d{6})$",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.pincode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter pincode.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone),
      expression: "zone"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "zone",
      "id": "zone",
      "placeholder": "Enter Zone Name"
    },
    domProps: {
      "value": (_vm.zone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zone = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Telephone No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telno),
      expression: "telno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "telno",
      "id": "telno",
      "placeholder": "Enter Telephone No"
    },
    domProps: {
      "value": (_vm.telno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telno = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Seller Address "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selleraddress),
      expression: "selleraddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('selleraddress')
    },
    attrs: {
      "type": "text",
      "name": "selleraddress",
      "id": "selleraddress",
      "placeholder": "Enter Seller Address"
    },
    domProps: {
      "value": (_vm.selleraddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selleraddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selleraddress')),
      expression: "errors.has('selleraddress')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter seller address.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "status",
      "name": "status"
    },
    domProps: {
      "checked": Array.isArray(_vm.status) ? _vm._i(_vm.status, "1") > -1 : (_vm.status)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.status = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.status = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "49rem"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v("   \n              "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clearForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ae88400","hasScoped":true}!./src/modules/cargobooking/views/booking/cargosellerdetails/createcargosellerdetails/createcargosellerdetails.component.html
// module id = 1267
// module chunks = 3